// extracted by mini-css-extract-plugin
module.exports = {"tocContainer":"ArticleTOC_tocContainer__qT46q","tocTitle":"ArticleTOC_tocTitle__QuUFA","tocLink":"ArticleTOC_tocLink__8ngqj","tocLinkArrow":"ArticleTOC_tocLinkArrow__JGnur"};